import React from 'react';
import {useTeam} from '../../context/TeamContext';
import ImprovementPointsList from '../planning/ImprovementPointsList';
export default function GeneralImprovementNotesTop(){const {teamId}=useTeam();return <ImprovementPointsList teamId={teamId}/>;}
